var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"clickable",attrs:{"to":{ name: 'Specialism', params: { alias: _vm.data.alias } }}},[_c('figure',{style:(_vm.background)}),_c('h4',[_vm._v(" "+_vm._s(_vm.data.pagetitle)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }